const EnvelopeIcon = () => {
  return (
    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.75 5.8125H19.25V17.5C19.25 17.6823 19.1776 17.8572 19.0486 17.9861C18.9197 18.1151 18.7448 18.1875 18.5625 18.1875H3.4375C3.25516 18.1875 3.0803 18.1151 2.95136 17.9861C2.82243 17.8572 2.75 17.6823 2.75 17.5V5.8125Z" fill="#00CECF" stroke="#00CECF" strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.25 5.8125L11 13.375L2.75 5.8125" stroke="white" strokeWidth="1.83333" strokeLinecap="square" strokeLinejoin="round"/>
      <circle cx="19" cy="6" r="4.75" fill="#E51D1D" stroke="white" strokeWidth="1.5"/>
    </svg>
  );
};

export default EnvelopeIcon;